<template>
  <div>

    <div class="google-map" :id="mapName"></div>

    <div class="container">
      <div id="locations-map">

        <div class="map-content">
          <h2>
            <span class="hide-mobile">Convenient Access</span><span class="show-mobile">Visit us</span> from VA, DC &amp; MD
          </h2>

          <a class="map-location" href="#annadale" @click="clickOverlay">
            <span class="location-name">Annandale, Virginia</span>
            <p>
              Annandale Square<br>
              4316 Evergreen Lane<br>
              Annandale, VA 22003<br>
              <span class="location-link">
                <a href="contact/annandale-va-fertility-center">View Map and Directions</a>
              </span>
            </p>
          </a>

          <a class="map-location" href="#fredericksburg" @click="clickOverlay">
            <span class="location-name">Fredericksburg, Virginia</span>
            <p> 
              2531 Cowan Blvd<br>
              Fredericksburg, VA 22401<br>
              <br>
              <span class="location-link">
                <a href="contact/fredericksburg-va-fertility-center">View Map and Directions</a>
              </span>
            </p>
          </a>

          <a class="map-location" href="#reston" @click="clickOverlay">
            <span class="location-name">Reston, Virginia</span>
            <p>
              Hospital Center Medical Plaza<br>
              1830 Town Center Dr., Suite 306<br>
              Reston, VA 22090<br>
              <span class="location-link">
                <a href="contact/reston-va-fertility-center">View Map and Directions</a>
              </span>
            </p>
          </a>

          <a class="map-location international" href="fertility-resources/international-domestic-patients">
            <span class="location-name">International Consultation</span>
            <p>
              Setup a skype consultation.
            </p>
          </a>
        </div>

      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.google-map {
  width: 100%;
  height: 50.3125rem;
  margin: 0 auto;
  background: gray;
  @media only screen and (max-width: 479px) {
    height: 40rem;
  }
}
</style>

<script>
  export default {
    name: 'GoogleMap',
    props: ['name'],
    data () {
      return {
        markers : [],
        mapName: this.name + '-map',
        zoom: 10,
        lat: 38.6523229,
        lng: -78.0580931,
        // markerOffsetX: 650,
        markerOffsetX: screen.width / 6.2,
        markerOffsetY: 200,
        markerCoordinates: [{
          record_id: 'Annadale',
          latitude: 38.830559,
          longitude: -77.1887537
        }, {
          record_id: 'Fredericksburg',
          latitude: 38.3076599,
          longitude: -77.4918788
        }, {
          record_id: 'Reston',
          latitude: 38.962612,
          longitude: -77.3668452
        }]
      }
    },
    mounted: function () {
      var component = this;
      // Responsive logic
      component.handleResize();
      window.addEventListener('resize', function() {
        component.handleResize();
      });
      // Map config
      const element = document.getElementById(this.mapName);
      const options = {
        zoom: component.zoom,
        center: new google.maps.LatLng(component.lat,component.lng),
        disableDefaultUI: true,
        styles: [
          {elementType: 'geometry', stylers: [{color: '#E7E6E4'}]},
          {elementType: 'labels.text.stroke', stylers: [{color: '#FFFFFF'}]},
          {elementType: 'labels.text.fill', stylers: [{color: '#151515'}]},
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{color: '#5D8DE2'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{color: '#FFFFFF'}]
          },
        ],
      };

      const map = new google.maps.Map(element, options);
      component.map = map;

      // Show markers
      component.markerCoordinates.forEach((coord) => {
        const position = new google.maps.LatLng(coord.latitude, coord.longitude);
        const marker = new google.maps.Marker({
          record_id : coord.record_id,
          position,
          map,
          icon: 'assets/images/wfc-pin-inactive.png'
        });
        marker.addListener('click', function(e) {
          var location = this.record_id;
          component.updateIcon('#'+location.toLowerCase());
        });
        component.markers.push(marker);
      });
    },
    methods: {
      clickOverlay: function(e) {
        e.preventDefault();
        var clicked = e.currentTarget;
        var location = clicked.getAttribute('href');
        if(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <= 1054) {
          var opens = document.querySelectorAll('.map-location.open');
          for (var i = 0; i < opens.length; i++) {
            opens[i].className = opens[i].className.replace(' open', '');
          }
          if (clicked.className.indexOf(' open') > -1) {
            clicked.className = clicked.className.replace(' open', '');
          } else {
            clicked.className += ' open';
          }
        }
        this.updateIcon(location);
      },
      updateIcon: function(location) {
        var locationsMap = document.getElementById('locations-map');
        var clicked = locationsMap.querySelector("a[href='"+ location +"']");
        var actives = document.querySelectorAll('.map-location.active');
        for (var i = 0; i < actives.length; i++) {
          if(actives[i].className.indexOf('active') > -1) {
            actives[i].className = actives[i].className.replace(' active', '');
          }
        }
        if(clicked.className.indexOf('active') <= -1) {
          clicked.className += ' active';
        }
        this.changeMarker(location.substr('1',location.length));
      },
      changeMarker: function(record_id) {
        var component = this;
        for (var i in component.markers) {
          if(component.markers[i].record_id.toLowerCase() == record_id){
            component.markers[i].setIcon('assets/images/wfc-pin-active.png');
            if(Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <= 1054) {
              component.offsetCenter(component.markers[i].position, 0, component.markerOffsetY);
            } else {
              component.offsetCenter(component.markers[i].position, component.markerOffsetX);
            }
          } else {
            component.markers[i].setIcon('assets/images/wfc-pin-inactive.png');
          }
        }
      },
      handleResize: function() {
        var component = this;
        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if(w <= 1334) {
          component.lat = 38.6523229;
          component.lng = -77.8580931;
          component.markerOffsetX = screen.width / 3;
        }
        if(w <= 1054) {
          component.zoom = 8;
          component.lat = 37.9523229;
          component.lng = -77.2580931;
        }
      },
      offsetCenter: function(latlng, offsetx, offsety) {
        var component = this;

        var scale = Math.pow(2, component.map.getZoom());

        var worldCoordinateCenter = component.map.getProjection().fromLatLngToPoint(latlng);
        var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);

        var worldCoordinateNewCenter = new google.maps.Point(
            worldCoordinateCenter.x - pixelOffset.x,
            worldCoordinateCenter.y + pixelOffset.y
        );

        var newCenter = component.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

        component.map.setCenter(newCenter);
      },
    }
  }
</script>
